define('apps/classrooms/views/pdf-utils/generate-grid-pdf-download',[
    "vendor/jspdf/jspdf",
    "apps/classrooms/views/pdf-utils/common",
    "apps/classrooms/views/pdf-utils/pdf-mixin",
],
/*eslint strict: [0, "function"]*/
function(
    jspdf,
    pdfCommonUtils,
    pdfMixin
) {
    /**
     * Takes a list of printable students and creates a PDF with
     *  a QR code and student details. For each PDF page, we display a 5 rows containing
     *  4 columns. After we have compiled all of the pages, create a PDF, and automatically prompt
     *  download. This layout follows the following Address Label sticker paper,
     *  Avery L7121-25 45mm x 45mm (although we have converted to inches).
     *
     * NOTE: This template is primarily used for UK users.
     */

    function calculateContentHeight(linesCount, qrSize, fontSize, lineSpacing){
        /*
        The value 72 is the number of points per inch, or in other words a point is 1/72 of an inch.
        This is why the fontSize, which would be in point units, is being divided by 72
        */
        var textHeight = linesCount * (fontSize / 72) + (linesCount - 1) * lineSpacing;
        return textHeight + qrSize;
    }

    function truncateText(pdf, text, maxWidth, hasParentheses) {
        if (pdf.getTextWidth(text) <= maxWidth){
            return text;
        }

        var truncatedText = text;
        while (pdf.getTextWidth(truncatedText + '...') > maxWidth) {
            if (truncatedText.length <= 1){
                return truncatedText;
            }
            truncatedText = truncatedText.slice(0, -1);
        }
        //remove one more character to accomodate the closing parentheses
        if (hasParentheses) {
            truncatedText = truncatedText.slice(0, -1) + '...' + ')';
        return truncatedText;
        }
        return truncatedText + '...';
    }

    function addQRAndTextToSticker(pdf, x, y, student, stickerHeight, stickerWidth) {
        //qr code size and line spacing can be adjusted as needed
        var qrSize = .75;
        var lineSpacing = 0.12;
        var studentNameLabel = this.getStudentLabelName(student);
        var maxTextWidth = stickerWidth - 0.2;
        var contentHeight = calculateContentHeight(5, qrSize, pdf.internal.getFontSize(), lineSpacing);
        var startY = y + (stickerHeight - contentHeight) / 2;

        startY += lineSpacing;
        pdf.text('Discovery Education', x + stickerWidth / 2, startY, { 'align': 'center' });

        startY += lineSpacing;
        pdf.text(truncateText(pdf, this.model.get('currentDomain'), maxTextWidth, false), x + stickerWidth / 2, startY, { 'align': 'center' });

        startY += lineSpacing / 2;
        pdf.addImage(
            student.qrAuth.qr_png_b64,
            'PNG',
            x + (stickerWidth - qrSize) / 2,
            startY,
            qrSize,
            qrSize
        );
        startY += qrSize + lineSpacing;

        if (studentNameLabel) {
            pdf.text(truncateText(pdf, studentNameLabel, maxTextWidth, false), x + stickerWidth / 2, startY, { 'align': 'center' });
           startY += lineSpacing;
        }

        pdf.text(truncateText(pdf, '(' + student.username + ')', maxTextWidth, true), x + stickerWidth / 2, startY, { 'align': 'center' });
        startY += lineSpacing;
        pdf.text(truncateText(pdf, student.qrAuth.localExpiryWithLabel, maxTextWidth, false), x + stickerWidth / 2, startY, { 'align': 'center' });
    }

    function buildGridPDF(targetStudents, isZip, zipFile, folderName) {
        var pdf = new jsPDF({ // eslint-disable-line new-cap
            "orientation": 'p',
            "unit": 'in',
            "format": 'a4',
        });

        // these dimension and spacing values were gathered from the website for the sticker sheet: https://www.avery.co.uk/product/qr-code-labels-l7121-25
        // mm to in conversion, stickers are 45 mm x 45 mm
        var stickerWidth = 45 / 10 / 2.54;
        var stickerHeight = 45 / 10 / 2.54;

        var rows = 5;
        var columns = 4;

        var topMargin = 1.03;
        var leftMargin = 0.3;
        var spaceBetweenStickersHorizontal = 0.20;
        var spaceBetweenStickersVertical = 0.20;

        var perPageTotal = 20;

        pdf.setFontSize(6);

        var studentChunks = pdfCommonUtils.generateChunks(targetStudents || this.model.get('printStudents'), perPageTotal),
            totalChunks = studentChunks.length;

        for (var sc = 0; sc < totalChunks; sc++) {
            var studentIndex = 0;
            for (var row = 0; row < rows; row += 1) {
                for (var col = 0; col < columns; col += 1) {
                    var student = studentChunks[sc][studentIndex];
                    if (!student) {
                        break;
                    }
                    var x = leftMargin + col * (stickerWidth + spaceBetweenStickersHorizontal);
                    var y = topMargin + row * (stickerHeight + spaceBetweenStickersVertical);
                    addQRAndTextToSticker(pdf, x, y, student, stickerHeight, stickerWidth);
                    studentIndex += 1;
                }
            }

            if (sc < totalChunks - 1) {
                pdf.addPage();
            }

            if (isZip) {
                zipFile.file(
                    folderName + '.pdf',
                    pdf.output('blob')
                );
            }
        }

        return isZip ? zipFile : pdf;
    };

    return function(isZip, model, forcePDFFormat) {
        this.model = model;
        this.buildLayout = buildGridPDF;

        $.each(Object.keys(pdfMixin), _.bind(function(_, key) {
            this[key] = pdfMixin[key];
        }, this));

        return this.buildTargetTypePDF(isZip, forcePDFFormat);
    };
});

